<ion-row class="proof">
    <ion-col size="12" size-md="4" [ngStyle]="{'border-bottom': bottomBorder ? '1px solid var(--ion-border)' : 'none' }">
        <div class="image-container"><img [src]="data.firstCol.img" [alt]="data.firstCol.alt ? data.firstCol.alt : data.firstCol.title"></div>
        <p class="dark header">{{data.firstCol.title}}</p>
        <p class="content">{{data.firstCol.content}}</p>
    </ion-col>
    <ion-col size="12" size-md="4" class="middleColumn" [ngStyle]="{'border-bottom': bottomBorder ? '1px solid var(--ion-border)' : 'none' }">
        <div class="image-container"><img [src]="data.secondCol.img" [alt]="data.secondCol.alt ? data.secondCol.alt : data.secondCol.title"></div>
        <p class="dark header">{{data.secondCol.title}}</p>
        <p class="content">{{data.secondCol.content}}</p>
    </ion-col>
    <ion-col size="12" size-md="4" [ngStyle]="{'border-bottom': bottomBorder ? '1px solid var(--ion-border)' : 'none', 'border-top': windowRef.width() <= 768 ? '1px solid var(--ion-border)' : 'none'  }">
        <div class="image-container"><img [src]="data.thirdCol.img" [alt]="data.thirdCol.alt ? data.thirdCol.alt : data.thirdCol.title"></div>
        <p class="dark header">{{data.thirdCol.title}}</p>
        <p class="content">{{data.thirdCol.content}}</p>
    </ion-col>
</ion-row>